// // import React, { useEffect, useState } from 'react';
// // import { useSelector } from 'react-redux';
// // // import purpleTheme from "./purple-passion.json";
// // // import * as echarts from "echarts/core";
// // // import { useSelector } from 'react-redux';
// // import SensorOne from './sensors/SensorOne';
// // import SensorTwo from './sensors/SensorTwo';
// // import SensorThree from './sensors/SensorThree';
// // import SensorFour from './sensors/SensorFour';


  
// // const DashboardPage = () => {
// //   const mode = useSelector((state) => state.darkMode);

// //   const { isdarkMode } = mode;
// //   const theme = isdarkMode
// //   // const {theme } = useSelector(state=>state.theme);  
// //   // console.log(theme)
// //   // echarts.registerTheme("purple-passion", purpleTheme);    

// //   return ( 
// //     <div className=' flex flex-col gap-5 overflow-hidden overflow-x-auto'>
// //       <SensorFour  theme = {theme === false?'light':'dark'}/>
// //         <div className="">
// //           <SensorOne  theme = {theme === false?'light':'dark'}/>
// //         </div>
// //         <div className="">  
// //         <SensorTwo  theme={theme  === false ? 'light':'dark'} />
// //         </div>
// //         <div className="">
// //         <SensorThree theme={theme  === false? 'light':'dark'} />
// //         </div>
// //     </div>
// //   )
// // }  

// // export default DashboardPage


// import React, { useState } from 'react';
// import { useSelector } from 'react-redux';
// import { Card, Select } from 'antd';
// import SensorOne from './sensors/SensorOne';
// import SensorTwo from './sensors/SensorTwo';
// import SensorThree from './sensors/SensorThree';
// import SensorFour from './sensors/SensorFour';
// import SensorFive from './sensors/SensorFive';

// const { Option } = Select;

// const DashboardPage = () => {
//   const mode = useSelector((state) => state.darkMode);
//   const { isdarkMode } = mode;
//   const theme = isdarkMode ? 'dark' : 'light';

//   const [selectedSensor, setSelectedSensor] = useState('default');

//   const renderSensor = () => {
//     switch (selectedSensor) {
//       case 'default':
//         return <div className='w-full '>
//         <SensorOne theme={theme} />
//          <SensorTwo theme={theme} />
//          <SensorThree theme={theme} />
//         </div> 
//       case 'Energy':
//         return <SensorFive theme={theme} />;
//       case 'Production':
//           return <SensorFour theme={theme} />;
//       default:
//         return  <>
//         <SensorOne theme={theme} />
//          <SensorTwo theme={theme} />
//          <SensorThree theme={theme} />
//         </>;
//     }
//   };

//   return (
//     <div className=' flex flex-col gap-5 overflow-hidden px-1'>
//       <Card className={`${theme==='dark'? 'bg-transparent':'bg-white'} `}>
//         <div className="flex justify-evenly">
//           <div className={` ${theme=='dark'?'text-white':'text-black'}  flex-1 text-2xl `}>
//           Dashboard
//           </div>
            
//         <div className="">
//       <Select
//         defaultValue='default'
//         onChange={(value) => setSelectedSensor(value)}
//         className='w-60'
//       >
//         <Option value='default'>Real Time Dashboard</Option>
//         <Option value='Energy'>Energy Dashboard</Option>
//         <Option value='Production'>Production Dashboard</Option> 
//       </Select>
//         </div>
//         </div>
//       </Card>
//       <div className=' w-full overflow-x-hidden px-2'>{renderSensor()}</div>
//     </div>
//   );
// };

// export default DashboardPage;



import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Select } from 'antd';
import SensorOne from './sensors/SensorOne';
import SensorTwo from './sensors/SensorTwo';
import SensorThree from './sensors/SensorThree';
import SensorFour from './sensors/SensorFour';
import SensorFive from './sensors/SensorFive';

const { Option } = Select;

const DashboardPage = () => {
  const mode = useSelector((state) => state.darkMode);
  const { isdarkMode } = mode;
  const theme = isdarkMode ? 'dark' : 'light';

  const sensorOptions = ['default', 'Energy', 'Production'];
  const [selectedSensor, setSelectedSensor] = useState(sensorOptions[0]);

  // Auto-change dropdown value every 3 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedSensor((prevSensor) => {
        const currentIndex = sensorOptions.indexOf(prevSensor);
        const nextIndex = (currentIndex + 1) % sensorOptions.length;
        return sensorOptions[nextIndex];
      });
    }, 180000); // 3 minutes in milliseconds

    return () => clearInterval(interval); // Clear on unmount
  }, []);

  const renderSensor = () => {
    switch (selectedSensor) {
      case 'default':
        return (
          <div className='w-full'>
            <SensorOne theme={theme} />
            <SensorTwo theme={theme} />
            <SensorThree theme={theme} />
          </div>
        );
      case 'Energy':
        return <SensorFive theme={theme} />;
      case 'Production':
        return <SensorFour theme={theme} />;
      default:
        return (
          <>
            <SensorOne theme={theme} />
            <SensorTwo theme={theme} />
            <SensorThree theme={theme} />
          </>
        );
    }
  };

  return (
    <div className='flex flex-col gap-5 overflow-hidden px-1'>
      <Card className={`${theme === 'dark' ? 'bg-transparent' : 'bg-white'}`}>
        <div className='flex justify-evenly'>
          <div className={`${theme === 'dark' ? 'text-white' : 'text-black'} flex-1 text-2xl`}>
            Dashboard
          </div>
          <div>
            <Select
              value={selectedSensor}
              onChange={(value) => setSelectedSensor(value)}
              className='w-60'
            >
              <Option value='default'>Real Time Dashboard</Option>
              <Option value='Energy'>Energy Dashboard</Option>
              <Option value='Production'>Production Dashboard</Option>
            </Select>
          </div>
        </div>
      </Card>
      <div className='w-full overflow-x-hidden px-2'>{renderSensor()}</div>
    </div>
  );
};

export default DashboardPage;
